import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export default function ProtectedRoute({ children, allow }) {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="min-h-screen bg-[#0B0F14] flex items-center justify-center text-gray-400">
        Cargando...
      </div>
    );
  }
  if (!user) return <Navigate to="/login" state={{ from: location.pathname }} replace />;

  if (allow && !user.roles.some((r) => allow.includes(r))) {
    return (
      <div className="min-h-screen bg-[#0B0F14] flex items-center justify-center text-gray-400">
        <div className="text-center">
          <p className="text-xl text-white">Acceso no autorizado</p>
          <p className="text-sm mt-2">Tu rol no tiene permisos para esta sección.</p>
        </div>
      </div>
    );
  }
  return children;
}
